import 'react-app-polyfill/stable'
import 'core-js'
import React from 'react'
import { Provider } from 'react-redux'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { store } from 'src/State-Management/store'
// import '../node_modules/react-bootstrap/dist/react-bootstrap'
import { createRoot } from 'react-dom/client'

import 'src/Sass/style.scss'
// import 'npm i react-bootstrap/'
// import 'src/Assets/style/DataGridCss.css'
import 'src/Assets/style/dataGrid.css'
import 'src/Assets/style/buttons.css'

createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    {/* <PersistGate loading={null} persistor={persistor}> */}
    <App />
  </Provider>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
